module.exports = __webpack_public_path__ + "media/zipship-video.65dd7ac9.mp4";